import React from 'react';
import '../../styles/NavBar.css';
import SideBar from './SideBar';

/**
 * NavBar ara actua com a wrapper del menú lateral (SideBar).
 * Es manté el mateix nom/import perquè totes les pàgines que fan
 * <NavBar/> obtinguin automàticament el menú lateral sense canvis.
 *
 * El SideBar és position: fixed a l'esquerra; el contingut de les
 * pàgines es desplaça mitjançant el marge global definit a NavBar.css.
 */
const NavBar = () => {
    return <SideBar/>;
};

export default NavBar;
